import { render, staticRenderFns } from "./GerarRelatoriosContratos.vue?vue&type=template&id=22b769e6&scoped=true&"
import script from "./GerarRelatoriosContratos.vue?vue&type=script&lang=js&"
export * from "./GerarRelatoriosContratos.vue?vue&type=script&lang=js&"
import style0 from "./GerarRelatoriosContratos.vue?vue&type=style&index=0&id=22b769e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b769e6",
  null
  
)

export default component.exports